import React, { useCallback, useState } from 'react';
import { useConfirmSignUpMutation, useSignUpMutation } from '../../api';
import { withErrorBoundary } from '../../layouts/RoutedErrorBoundary';
import { OtpConfigProps } from '../../routes/LoginRoute';
import { useHandleError } from '../../utilities/handleErrors';
import OTPPage, { OTPFormValues } from '../OTPPage';
import { SignUpFormValues, SignUpSuccessModal, prepareSignUpPayload } from './components';

export type SignUpPageValidationProps = {
    validation: {
        values: SignUpFormValues;
        token: string;
    };
    otpConfig: OtpConfigProps;
};

const SignUpValidation = ({ validation, otpConfig }: SignUpPageValidationProps) => {
    const { values, token: initialToken } = validation;
    const { mobilePhone } = values;
    const [token, setToken] = useState(initialToken);
    const [confirm] = useConfirmSignUpMutation();
    const [signUp] = useSignUpMutation();
    const [completed, setCompleted] = useState(false);

    const handleSubmit = useHandleError(
        async ({ code }: OTPFormValues) => {
            await confirm({
                variables: {
                    token,
                    mobilePhone,
                    code: code.join(''),
                },
            });

            setCompleted(true);
        },
        [token, mobilePhone, setCompleted]
    );

    const resendCode = useCallback(
        sendByEmail => {
            const fields = prepareSignUpPayload(values);
            signUp({ variables: { fields: { ...fields, sendOtpByEmail: sendByEmail } } })
                .then(({ data }) => setToken(data.registerNewAccount))
                .catch(console.warn);
        },
        [setToken, signUp, values]
    );

    return (
        <>
            <SignUpSuccessModal show={completed} />
            <OTPPage handleSubmit={handleSubmit} otpConfig={otpConfig} resendCode={() => resendCode(true)} />
        </>
    );
};

export default withErrorBoundary(SignUpValidation);
